import { useQuery } from 'react-query'
import { KEYS, DEFAULT_FILTERS } from 'features/workflows/constants'
import { RawWorkflowListFilters } from 'features/workflows/types'
import { WorkflowsPermissionsType } from 'features/workflows/enums'
import { useWorkflowsPermissionsMapping } from './useWorkflowsPermissionsMapping'
import { workflowClient } from '../../service/clients/WorkflowClient'
import { useMeUser } from 'features/users/hooks/useMeUser'
import { getRoleInfo } from 'features/users/model/user'
import { UserRole } from 'features/users'

export function useLatestWorkflows() {
  const user = useMeUser()
  const isGuest = getRoleInfo(user).role === UserRole.Guest
  const permissionsMapping = useWorkflowsPermissionsMapping()
  const defaultFilter: RawWorkflowListFilters = {
    ...DEFAULT_FILTERS,
    permissions: permissionsMapping(WorkflowsPermissionsType.All)
  }

  return useQuery([KEYS.latestWorkflows, defaultFilter, 4], (params) => workflowClient.getList(params), {
    enabled: !isGuest
  })
}
